module.exports = __webpack_public_path__ + "static/media/wazeba-black.b5f7826d.gif";